import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=0843cf80&scoped=true&"
import script from "./Home.vue?vue&type=script&lang=js&"
export * from "./Home.vue?vue&type=script&lang=js&"
import style0 from "./Home.vue?vue&type=style&index=0&id=0843cf80&scoped=true&lang=css&"
import style1 from "./Home.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0843cf80",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/gate/releases/20261022070252/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0843cf80')) {
      api.createRecord('0843cf80', component.options)
    } else {
      api.reload('0843cf80', component.options)
    }
    module.hot.accept("./Home.vue?vue&type=template&id=0843cf80&scoped=true&", function () {
      api.rerender('0843cf80', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/pages/Home.vue"
export default component.exports